import { TimeFormat } from '@ac/library-api';

export const DEFAULT_DATE_TIME_FORMATS = {
  longDate: 'dddd, MMMM dd, YYYY',
  shortDate: 'DD/MM/YYYY',
  time12h: 'hh:mm A',
  time24h: 'HH:mm',
  timeFormatCode: TimeFormat.H24,
};
